import { useState, useEffect } from 'react'
import { Bot } from 'lucide-react'
import { getDiscordAuthUrl, checkAuth, setAuthToken } from '../api'

export function LoginPage() {
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const hashParams = new URLSearchParams(window.location.hash.substring(1))
    const token = hashParams.get('token')
    if (token) {
      setAuthToken(token)
      window.history.replaceState({}, '', window.location.pathname)
      checkAuth().then(() => {
        // Redirect to dashboard with token
        const dashboardUrl = import.meta.env.VITE_DASHBOARD_URL || 'https://unstablepvp-dashboard.pages.dev'
        window.location.href = `${dashboardUrl}#token=${token}`
      })
    } else {
      checkAuth().then((u) => {
        if (u) {
          // Redirect to dashboard
          const dashboardUrl = import.meta.env.VITE_DASHBOARD_URL || 'https://unstablepvp-dashboard.pages.dev'
          window.location.href = dashboardUrl
        } else {
          setLoading(false)
        }
      })
    }
  }, [])

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bg">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-accent mx-auto mb-4"></div>
          <p className="text-fg-muted">Loading...</p>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-bg p-4">
      <div className="max-w-md w-full animate-fade-in-up">
        <div className="text-center mb-8">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-2xl bg-accent text-accent-fg">
            <Bot size={32} />
          </div>
          <h1 className="text-3xl font-semibold text-fg mb-2 tracking-tight">UnstablePvP</h1>
          <p className="text-fg-muted text-sm">Discord Bot Dashboard</p>
        </div>

        <div className="bg-surface rounded-xl border border-border p-8 shadow-sm">
          <div className="text-center mb-6">
            <h2 className="text-xl font-semibold text-fg mb-2">Login Required</h2>
            <p className="text-sm text-fg-muted">Sign in with Discord to manage your servers.</p>
          </div>

          <a
            href={getDiscordAuthUrl()}
            className="w-full bg-accent hover:bg-accent/90 active:bg-accent/80 text-accent-fg px-6 py-2.5 rounded-md font-medium transition-colors flex items-center justify-center gap-2 hover:scale-[1.02] active:scale-[0.98] transition-transform duration-150"
          >
            <Bot size={18} />
            Login with Discord
          </a>

          <div className="mt-6 text-center">
            <p className="text-xs text-fg-subtle">
              By logging in, you agree to the UnstablePvP terms of service.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LoginPage